import "bootstrap"; // Import Bootstrap JS
import "./assets/scss/styles.scss";
import {
  getPostDetail,
  getPostList,
} from "./assets/js/components/post.component";
import { getBanners } from "./assets/js/components/banner.component";
import { loadPostsFromBtn } from "./assets/js/infinite-scroll";
import { getMenu, toggleMobileMenu, closeMenu } from "./assets/js/menu";
import { initForms } from "./assets/js/utils/form.util";
import { sendContactForm } from "./assets/js/send-contact-form";
import { sendNewsForm } from "./assets/js/send-newsletter-form";
import { sendProcessForm } from "./assets/js/send-process-form";
import {
  openFormProcessModal,
  closeFormProcessModal,
  calcFloatBtnPosition,
} from "./assets/js/process-form-modal";

const getCurrentYear = () => {
  const spanYear = document.getElementById("get-year");
  const currentDate = new Date().getFullYear();
  spanYear.innerHTML = currentDate;
};

getMenu();
toggleMobileMenu();
closeMenu();
getCurrentYear();
getPostList();
getPostDetail();
getBanners();
loadPostsFromBtn();
initForms([
  {
    id: "qte-form",
    sendFn: sendContactForm,
  },
  {
    id: "news-form",
    sendFn: sendNewsForm,
  },
  {
    id: "process-form",
    sendFn: sendProcessForm,
  },
]);
openFormProcessModal();
closeFormProcessModal();
calcFloatBtnPosition();
